<template>
    <div class="card" v-if="learners">

        <div class="card-header" v-if="group">
            <div class="row">
                <div class="col">
                    <h3 class="mb-0 text-uppercase">
                        <a href="#" class="text-muted" @click.prevent="backToCohort">
                            {{ registration.cohort.name }}
                        </a> /
                        {{ group.name }}
                    </h3>
                </div>
            </div>
        </div>

        <p class="card-body mb-0 text-sm" v-if="empty">{{ $t('dashboard.no-learner') }}</p>

        <div :class="{ 'pt-3': !group }" v-if="!empty">
            
            <table-control :paging="paging" :search="true" v-model="search" v-if="!group"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="filteredLearners">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle" :class="{'disabled': isWithdrawed(row)}"
                                @click.prevent="openLearner(row)">
                            <img :src="row.avatar">
                        </a>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <div :class="{'disabled': isWithdrawed(row)}">
                            <h4 class="mb-0">
                                <a href="#" @click.prevent="openLearner(row)">
                                    {{row.name}}
                                </a>
                            </h4>
                            <small v-if="row.owner">
                                {{ row.owner.name }}
                            </small>
                            <small v-if="row.entity">
                                / {{ row.entity.name }}
                            </small>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <base-progress type="info" :value="progress(row)">
                        </base-progress>

                        <span class="d-block">
                            <strong>{{ progress(row) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                            <span v-if="row.state.remedial_sessions">
                                + <strong>{{ row.state.remedial_sessions }}</strong> {{ $t('dashboard.remedial-s').toLowerCase() }}
                            </span>
                        </span>

                        <small class="d-block mt-1" v-if="row.state.meta && row.state.meta.go_ground">
                            <i class="fas fa-plane-departure mr-1"></i>
                            {{ $t('degrees.go-ground') }}
                        </small>

                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" width="120">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" @click="openLearner(row)">
                                {{ $t('dashboard.more') }}
                            </base-button>

                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <table-pagination :paging="paging" v-if="!group"></table-pagination>                
        </div>

        <div class="card-footer text-center" v-if="group">
            <base-button type="secondary" size="sm" @click="backToCohort">
                {{ $t('dashboard.back-to-cohort') }}
            </base-button>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
            },

            learners: {
                type: Array,
            },

            group: {
                type: Object,
            }
        },

        data() {
            return {
                paging: {
                    currentPage: 1,
                    perPage: 10,
                    total: 0
                },
                search: '',
            }
        },

        computed: {

            empty() {
                return this.learners.length == 0 && !this.search
            },

            filteredLearners() {
                // Search filter.
                let learners = this.learners.filter(learner => !this.search
                    || learner.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                learners = learners.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)

                // Paging.
                if (this.group) {
                    return learners
                } else {
                    this.paging.total = learners.length
                    return learners.slice((this.paging.currentPage - 1) * this.paging.perPage, this.paging.currentPage * this.paging.perPage)
                }
            },
        },

        methods: {     

            isWithdrawed(row) {
                return !row.pivot.active
            },

            progress(learner) {
                if (learner.state.empty || learner.state.sessions_count == 0) {
                    return 0
                }
                let progress = (learner.state.completed_sessions ? learner.state.completed_sessions : 0) * 100 / learner.state.sessions_count
                return parseInt(progress)
            },

            openLearner(learner) {
                this.$router.push({ name: 'dashboard-learner-registration',
                    params: {
                        learnerId: learner.id,
                        registrationId: this.registration.id
                    }
                })
            },

            backToCohort() {
                this.$router.push({ name: 'dashboard-cohort-registration',
                    params: {
                        cohortId: this.registration.cohort.id,
                        registrationId: this.registration.id
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }
    .disabled, .disabled h4 {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }

</style>
